export enum ComponentTypeReportingDefaults {
  DTVMARQUEE = "dtvMarquee",
  DTVCAROUSEL = "dtvCarousel",
  CHANNEL_COMPARISON_TOOL = "CHANNEL_COMPARISON_TOOL",
  FAQ = "faqPanel",
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  FAQV2 = "faqPanel",
  FORM_BUILDERV2 = "formBuilder",
  BREADCRUMBSV2 = "breadCrumbs",
  QUIZV2 = "quizComponent",
  EMAILPOPUPMODAL = "emailPopupModal",
  ROWCANVASV2 = "rowCanvas",
  FLOATINGWIDGETV2 = "floatingWidget",
  // W&C MUI5 Comps
  LONGFORMATCARD = "dtvLongFormatCard",
  CONTENTCARDS = "contentCard",
  PAGESECTIONHEADER = "dtvPageSectionHeader",
  PLANCARD = "dtvPlanCard",
  INPAGELEGAL = "dtvInPageLegal",
  INTERNALPRODCUTCOMPARISIONCHART = "internalProductComparisionChart",
  DTVHERO = "dtvHero",
  VERTICALSPACER = "dtvVerticalSpacer",
  HEADLINE = "dtvHeadline",
  LIST_ITEM = "dtvListItem",
  FOUR_UP_ICON_LIST = "dtv4UpIconListItem",
  MESSAGINGBANNER = "dtvMessagingBanner",
  MESSAGINGCARD = "dtvMessagingCard",
  EXTERNALSERVICECOMPARISON = "dtvExternalServiceComparison",
  EXTERNALSERVICECOMPARISONTABS = "dtvExternalServiceComparisonChartTabs",
  DTV1UP2UPMEDIA = "dtv1Up2UpMedia",
  DTVIFRAME = "iframe",
  DTVLINKFARM = "dtvLinkFarm",
  AGNOSTICPLANCARDS = "dtvAgnosticPlanCards",
  INSIDERARTICLE = "insiderPanel",
  FINDRETAILER = "findRetailer",
  CHANNELLOGOCAROUSAL = "channelLogoCarousal",
  DTVFIRSTNAME = "dtvFirstName",
  DTVTHREEUP = "dtvThreeUp",
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  LINKFOREST = "dtvLinkFarm",
  PACKAGECOMPARISONCALCULATOR = "PACKAGECOMPARISONCALCULATOR",
  LOCALCHANNELSLOOKUPPAGE = "LOCALCHANNELSLOOKUPPAGE",
  DTVFLASH = "dtvFlash",
  DTVCOUNTDOWN = "dtvCountDown",
  EXITMODAL = "exitModal",
  VIDEOMARQUEECAMPAIGN = "videoMarqueeCampaign",
  RSNLOOKUPTOOL = "RsnLookupTool",
  SITEMAP = "siteMap",
}

export interface ReportingDefaultsData {
  [key: string]: any;
}
export const LINK_POSITION_BODY = "Body";
export const ReportingDefaults: ReportingDefaultsData = {
  breadCrumbs: {
    contentFriendlyName: `breadCrumbs`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  carousel: {
    contentFriendlyName: `package card`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  faqPanel: {
    Infinity: {
      contentFriendlyName: `FAQ_PANEL`,
      contentProductGroup: ``,
      contentSystem: "SB"
    }
  },
  gvpPanel: {
    Infinity: {
      contentFriendlyName: `GVP_Panel`,
      contentProductGroup: ``,
      contentSystem: "SB"
    }
  },
  heroPanel: {
    Infinity: {
      contentFriendlyName: `Deals_Big_Brands_Bigger_Savings`,
      contentProductGroup: ``,
      contentSystem: "SB"
    }
  },
  quizComponent: {
    Infinity: {
      contentFriendlyName: `Deals_Quiz_Form`,
      contentProductGroup: ``,
      contentSystem: "SB"
    }
  },
  alert: {
    contentFriendlyName: `alertbanner`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  formBuilder: {
    contentFriendlyName: `formBuilder`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  cardgridlist: {
    contentFriendlyName: `package card`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  table: {
    contentFriendlyName: `table`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  canvas: {
    contentFriendlyName: `canvas`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  iframe: {
    contentFriendlyName: `iframe`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  channelsBoard: {
    contentFriendlyName: `channels board`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  floatingWidget: {
    Infinity: {
      contentFriendlyName: `floating widget`,
      contentProductGroup: ``,
      contentSystem: "SB"
    }
  },
  dtvExternalScriptLoader: {
    contentFriendlyName: `dtv-external-script-loader`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  UcgGalleryLoader: {
    contentFriendlyName: `ucg-gallery-loader`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  PkgComparisonModalV2: {
    contentFriendlyName: `pkg-compare-modal-V2`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvLongFormatCard: {
    contentFriendlyName: `dtv-long-format-card`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  contentCard: {
    contentFriendlyName: `dtv-content-card`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvMarquee: {
    contentFriendlyName: `dtv-marquee`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  rotatingMarque: {
    contentFriendlyName: `rotating-marque`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvCountDown: {
    contentFriendlyName: `dtv-countDown`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  VideoMarqueeCampaign: {
    contentFriendlyName: `dtv-VideoMarqueeCampaign`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  exitModal: {
    contentFriendlyName: `dtv-exitModal`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvEntertainmentCarousel: {
    contentFriendlyName: `dtv-carousel`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvFindRetailer: {
    contentFriendlyName: `dtv-find-retailer`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  internalProductComparisionChart: {
    contentFriendlyName: `dtv-internal-product-comparision-chart`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvPageSectionHeader: {
    contentFriendlyName: `dtv-page-section-header`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvPlanCard: {
    contentFriendlyName: `dtv-page-plan-card`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvInPageLegal: {
    contentFriendlyName: `dtv-in-page-legal`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvVerticalSpacer: {
    contentFriendlyName: `dtv-vertical-spacer`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvHeadline: {
    contentFriendlyName: `dtv-headline`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvListItem: {
    contentFriendlyName: `dtv-list-item`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtv4UpIconListItem: {
    contentFriendlyName: `dtv-4up-icon-list-item`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvHero: {
    Infinity: {
      contentFriendlyName: `dtv-hero`,
      contentProductGroup: ``,
      contentSystem: "SB"
    }
  },
  dtvMessagingBanner: {
    contentFriendlyName: `dtv-messaging-banner`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvMessagingCard: {
    contentFriendlyName: `dtv-messaging-card`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvMduHero: {
    contentFriendlyName: `dtv-mdu-hero`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvExternalServiceComparison: {
    contentFriendlyName: `dtv-external-service-comparison`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvExternalServiceComparisonChartTabs: {
    contentFriendlyName: `dtv-external-service-comparison-chart-tabs`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtv1Up2UpMedia: {
    Infinity: {
      contentFriendlyName: `dtv-1up-2up-media`,
      contentProductGroup: ``,
      contentSystem: "SB"
    }
  },
  dtviframe: {
    contentFriendlyName: `dtviframe`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvLinkFarm: {
    contentFriendlyName: `dtv-linkfarm`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvAgnosticPlanCards: {
    Infinity: {
      contentFriendlyName: `dtv-agnostic-plancards`,
      contentProductGroup: ``,
      contentSystem: "SB"
    }
  },
  insiderPanel: {
    Infinity: {
      contentFriendlyName: `INSIDER_PANEL`,
      contentProductGroup: ``,
      contentSystem: "SB"
    }
  },
  channelLogoCarousal: {
    contentFriendlyName: `channel-logo-carousal`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvFirstName: {
    contentFriendlyName: `First Name`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  dtvThreeUp: {
    contentFriendlyName: `Three up component`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  PACKAGECOMPARISONCALCULATOR: {
    contentFriendlyName: `Package Comparision Savings Calculator`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  LOCALCHANNELSLOOKUPPAGE: {
    contentFriendlyName: `Local Channels Lookup Page`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  marketingBanner: {
    contentFriendlyName: `Marketing Banner`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  showCarousal: {
    contentFriendlyName: `Show Carousal`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  searchComponent: {
    ContentFriendlyName: `Search`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  searchWatchNow: {
    contentFriendlyName: `Search Watch Now`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  seoContent: {
    contentFriendlyName: `Seo Content`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  RsnLookupTool: {
    contentFriendlyName: `RSN Lookup Tool`,
    contentProductGroup: ``,
    contentSystem: "SB"
  },
  LocalRsnTool: {
    contentFriendlyName: `Local RSN Tool`,
    contentProductGroup: ``,
    contentSystem: "SB"
  }
};
